(function () {
  'use strict';

  function whereToFactory (apiFactory, Common, moment, $rootScope) {
    const factory = {};

    factory.weightUnits = {
      kilo: 'kg',
      grams: 'g'
    };

    function getRecipientsCount () {
      const recipients = {
        FILE: parseInt(Common.get('recipients.validAddressCount', 0)),
        INDIVIDUALS: parseInt(Common.get('recipients.refinedAddressCount', 0)),
        COMPANIES: parseInt(Common.get('recipients.refinedAddressCount', 0)),
      };

      return recipients[Common.get('recipients.targetType', 'FILE')];
    }

    // this is for checking the value of preface in materials page
    factory.preface = Common.get('preface', false);
    factory.productChanged = false;

    function checkInteger (val) {
      let newVal = val;
      let integer = val.split(',')[0];

      if (integer.length > 3) {
        integer = parseInt(integer) / 1000;
        newVal = integer.toFixed(3) + ',' + val.split(',')[1];
      }

      return newVal;
    }

    function addDecimal (price) {
      let val = parseInt((price || 0)) / 100;
      val = val.toFixed(2);
      val = val.replace('.', ',');
      val = checkInteger(val);

      return val;
    }

    function addIconUrl (item) {
      item.icon = 'assets/images/' + item.icon;

      return item;
    }

    function filterProducts (item) {
      const serviceType = Common.get('serviceType');

      return item.siteCategory === serviceType; //information or paymentSlips, need to do something else for reklamfixaren I think
    }

    function getPostage (postageProducts) {
      const recipients = getRecipientsCount();
      const postages = postageProducts.filter(function (item) {
        return recipients >= item.limits.count.min && recipients <= item.limits.count.max;
      });

      return postages;
    }

    function iterateToAddDecimal (item) {
      item.price = addDecimal(item.price);

      return item;
    }

    function filterDiscounts (item) {
      const recipients = getRecipientsCount();
      return recipients >= item.limits.count.min;
    }

    function addToPrice (price, arr) {
      arr.forEach(function (item) {
        price = parseInt(price) + parseInt(item.price);
      });

      return price;
    }

    function deductPrice (price, arr) {
      const recipients = getRecipientsCount();
      arr.forEach(function (item) {
        if (item.limits.count.min <= recipients) {
          price = parseInt(price) - parseInt(item.price);
        }
      });

      return price;
    }

    function modifyDeliveryOption (item) {
      if (!item.postageProducts) {
        return item;
      }
      item.postageProducts = getPostage(item.postageProducts);

      item.postageProducts.forEach(function (postageProduct, postageIndex) {
        let price = item.postageProducts[postageIndex].price_model.per_piece;

        if (item.postageProducts[postageIndex].price_model.per_weight_unit) {
          const weightPriceVal = addDecimal(item.postageProducts[postageIndex].price_model.per_weight_unit.price);
          item.postageProducts[postageIndex].price_model.per_weight_unit.price = weightPriceVal;
        }

        if (item.postageProducts[postageIndex].price_model.lowest_price) {
          const lowestPriceVal = addDecimal(item.postageProducts[postageIndex].price_model.lowest_price.price);
          item.postageProducts[postageIndex].price_model.lowest_price.price = lowestPriceVal;
        }

        if (item.additionalServices) {
          price = addToPrice(price, item.additionalServices);
          if (item.additionalServices[0].price.toString().indexOf(',') > -1) {
            item.postageProducts[postageIndex].additionalServices = item.additionalServices.map(iterateToAddDecimal)[0];
          }
        }

        if (item.discountsProducts) {
          price = deductPrice(price, item.discountsProducts);
          item.postageProducts[postageIndex].discountsProducts = item.discountsProducts
            .map(iterateToAddDecimal)
            .filter(filterDiscounts)[0];
        }

        item.postageProducts[postageIndex].price = addDecimal(price);

      });

      return item;
    }

    function mapDeliveryOptions (info) {
      return info.deliveryOptions.map(modifyDeliveryOption.bind({
        'units': info.units,
        'piece': info.piece
      }));
    }

    function selectPriceLadderOptions (priceLadder) {
      const validAddressCount = getRecipientsCount();

      return priceLadder.map(function (ladder) {
        ladder.pricing = ladder.pricing.filter(function (pricing) {
          return pricing.min <= validAddressCount && validAddressCount <= pricing.max;
        });
        return ladder;
      });
    }

    function mapProducts (item) {
      if (item.restructured) {
        return item;
      }
      item.restructured = true;
      if (item.pricingInfo.printingInfo) { //should make this generic..
        if (item.pricingInfo.printingInfo.extraPage) {
          item.pricingInfo.printingInfo.extraPage.price = addDecimal(item.pricingInfo.printingInfo.extraPage.price);
        }
        if (item.pricingInfo.printingInfo.basePrice) {
          item.pricingInfo.printingInfo.basePrice.price = addDecimal(item.pricingInfo.printingInfo.basePrice.price);
        }
        if (item.pricingInfo.printingInfo.printPrice) {
          item.pricingInfo.printingInfo.printPrice.price = addDecimal(item.pricingInfo.printingInfo.printPrice.price);
        }

      }
      if (item.pricingInfo.priceLadder) {
        item.pricingInfo.priceLadder = selectPriceLadderOptions(item.pricingInfo.priceLadder)
          .map(function (ladder) {
            if (ladder.pricing.length) {
              ladder.pricing[0].price = addDecimal(ladder.pricing[0].price);
            }

            return ladder;
          });
      }

      const addresstype = Common.get('recipients').addressType;
      if (item.pricingInfo[addresstype]) {
        item.pricingInfo[addresstype].priceLadder = selectPriceLadderOptions(item.pricingInfo[addresstype].priceLadder)
          .map(function (ladder) {
            if (ladder.pricing.length) {
              ladder.pricing[0].price = addDecimal(ladder.pricing[0].price);
            }
            return ladder;
          });
      }

      if (item.pricingInfo.deliveryOptions[0].adrAddresses) {
        item.pricingInfo.deliveryOptions[0].adrAddresses.price =
          addDecimal(item.pricingInfo.deliveryOptions[0].adrAddresses.price);
      }

      item.pricingInfo.deliveryOptions = mapDeliveryOptions(item.pricingInfo);
      item = addIconUrl(item);

      return item;
    }

    function restructureProducts (data) {
      const products = angular.copy(data);

      return products.filter(filterProducts)
        .map(mapProducts);
    }

    function restructureDeliveryOption (delivery, day) {
      delivery.deliveryDays = day;
      return delivery;
    }


    function storeSelection (product, date, delivery, preface, deliveryDay) {
      const data = angular.copy(product);
      const oldProductId = Common.get('productDelivery', {}).productId;
      // setting it to old preface or if there is none, default to false
      /// this is for the pdf validation
      factory.preface = angular.copy(Common.get('preface', false));

      if (oldProductId && oldProductId !== data.productId) {
        factory.productChanged = true;
      }

      data.deliveryDate = moment(date);
      data.pricingInfo.deliveryOptions = !deliveryDay ? delivery : restructureDeliveryOption(delivery, deliveryDay);
      data.numberOfRecipients = getRecipientsCount();
      Common.set('singleSided', product.singleSided);
      Common.set('productDelivery', data);
      Common.set('preface', preface); // setting new preface value
    }

    function addIconPath (products) {
      return products.map(addIconUrl);
    }

    factory.restructureProducts = restructureProducts;
    factory.storeSelection = storeSelection;
    factory.addIconPath = addIconPath;
    factory.getRecipientsCount = getRecipientsCount;

    return factory;
  }

  angular.module('web2print.whereTo')
    .factory('whereToFactory', whereToFactory);

  whereToFactory.$inject = ['apiFactory', 'Common', 'moment', '$rootScope'];
})();
